import { render } from "./MarketplaceChannelTabs.vue?vue&type=template&id=23529b04&scoped=true"
import script from "./MarketplaceChannelTabs.vue?vue&type=script&lang=js"
export * from "./MarketplaceChannelTabs.vue?vue&type=script&lang=js"

import "./MarketplaceChannelTabs.vue?vue&type=style&index=0&id=23529b04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23529b04"]])

export default __exports__